import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let authError: string | null = null;

const requiredKeys = [
  "VITE_FIREBASE_API_KEY",
  "VITE_FIREBASE_AUTH_DOMAIN",
  "VITE_FIREBASE_PROJECT_ID",
] as const;

const missingKeys = requiredKeys.filter((key) => {
  const value = import.meta.env[key];
  return !value || String(value).trim().length === 0;
});

const allowStubAuth =
  import.meta.env.DEV && import.meta.env.VITE_ALLOW_STUB_AUTH === "true";

if (missingKeys.length === 0) {
  try {
    app = initializeApp({
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
    });
    auth = getAuth(app);
  } catch (error) {
    authError = "Falha ao inicializar autenticação Firebase.";
    console.error("Firebase initialization failed", error);
  }
} else {
  authError = `Configuração ausente do Firebase: ${missingKeys.join(", ")}`;
  console.error(authError);
}

export { auth };
export const isStubAuthEnabled = allowStubAuth && !auth;
export const isAuthConfigured = !!auth || isStubAuthEnabled;
export const firebaseAuthError = authError;
export default app;
